module.exports = __webpack_public_path__ + "static/media/alarm-clock.21e516f7.svg";